export default __webpack_public_path__ + "static/media/landing-track-anywhere.008117b0.png";